export interface ProfileAddress {
  id: string
  label: string
  street: string
  city: string
  postalCode: string
  primary: boolean
}

export interface NotificationChannel {
  id: string
  label: string
  description: string
  enabled: boolean
}

export interface NotificationTopic {
  id: string
  label: string
  description: string
  enabled: boolean
  essential: boolean
}

export interface Consent {
  id: string
  title: string
  purpose: string
  grantedOn: string
  status: 'accorde' | 'a-confirmer'
  withdrawable: boolean
}

export interface Invoice {
  id: string
  date: string
  service: string
  reference: string
  amount: string
  status: 'payee' | 'a-payer'
}

export interface PolicyDoc {
  id: string
  title: string
  description: string
}

export const profile = {
  firstName: 'Charlotte',
  lastName: 'Bouchard',
  initials: 'CB',
  birthDate: '1970-02-04',
  phone: '(418) 939-0210',
  phoneSecondary: '',
  mobile: '(418) 555-0184',
  email: 'charlotte.bouchard@courriel.com',
}

export const addresses: ProfileAddress[] = [
  {
    id: 'principale',
    label: 'Résidence',
    street: '112, route 138',
    city: 'Baie-Trinité (Québec)',
    postalCode: 'G0H 1A0',
    primary: true,
  },
  {
    id: 'villegiature',
    label: 'Chalet — bail de villégiature',
    street: 'Chemin du Vieux-Phare, Pointe-des-Monts',
    city: 'Baie-Trinité (Québec)',
    postalCode: 'G0H 1A0',
    primary: false,
  },
]

export const notificationChannels: NotificationChannel[] = [
  { id: 'courriel', label: 'Courriel', description: 'charlotte.bouchard@courriel.com', enabled: true },
  { id: 'sms', label: 'SMS', description: '(418) 555-0184', enabled: true },
  { id: 'push', label: 'Notifications mobiles', description: 'Application bciti+', enabled: false },
]

export const notificationTopics: NotificationTopic[] = [
  {
    id: 'alertes',
    label: 'Alertes importantes',
    description: 'Sécurité civile, avis d’ébullition, tempêtes et pannes.',
    enabled: true,
    essential: true,
  },
  {
    id: 'avis',
    label: 'Avis à la population',
    description: 'Séances du conseil, avis publics, fermetures du bureau municipal.',
    enabled: true,
    essential: false,
  },
  {
    id: 'services',
    label: 'Services et opérations',
    description: 'Collectes, horaire du centre de tri, voirie et déneigement.',
    enabled: true,
    essential: false,
  },
  {
    id: 'loisirs',
    label: 'Vie communautaire',
    description: 'Activités, bibliothèque, évènements du village.',
    enabled: false,
    essential: false,
  },
  {
    id: 'rappels',
    label: 'Rappels personnalisés',
    description: 'Échéances de taxes, renouvellement du bail de villégiature, permis.',
    enabled: true,
    essential: false,
  },
]

export const consents: Consent[] = [
  {
    id: 'communications',
    title: 'Communications électroniques',
    purpose: 'Recevoir les avis et les communications de la Municipalité par courriel et par SMS.',
    grantedOn: 'Accordé le 12 mars 2026',
    status: 'accorde',
    withdrawable: true,
  },
  {
    id: 'personnalisation',
    title: 'Utilisation de mes données pour personnaliser mes services',
    purpose: 'Afficher les collectes, rappels et services correspondant à votre adresse.',
    grantedOn: 'Accordé le 12 mars 2026',
    status: 'accorde',
    withdrawable: true,
  },
  {
    id: 'partage',
    title: 'Partage de données avec un service municipal connecté',
    purpose:
      'Transmettre votre dossier à la bibliothèque municipale pour activer votre carte citoyenne.',
    grantedOn: 'Demandé le 21 août 2026',
    status: 'a-confirmer',
    withdrawable: false,
  },
]

export const invoices: Invoice[] = [
  {
    id: 'f-1042',
    date: '14 août 2026',
    service: 'Bail de villégiature — saison 2026',
    reference: 'FAC-1042',
    amount: '285,00 $',
    status: 'a-payer',
  },
  {
    id: 'f-0987',
    date: '2 juillet 2026',
    service: 'Permis de rénovation',
    reference: 'FAC-0987',
    amount: '120,00 $',
    status: 'payee',
  },
  {
    id: 'f-0912',
    date: '3 mars 2026',
    service: 'Taxes municipales — 1er versement',
    reference: 'FAC-0912',
    amount: '842,50 $',
    status: 'payee',
  },
]

export const policyDocs: PolicyDoc[] = [
  {
    id: 'vie-privee',
    title: 'Espace vie privée',
    description: 'Comment vos renseignements personnels sont protégés et utilisés.',
  },
  {
    id: 'conditions',
    title: 'Conditions d’utilisation',
    description: 'Les règles applicables à l’utilisation des services numériques.',
  },
  {
    id: 'charte-ia',
    title: 'Charte éthique de l’IA',
    description:
      'Nos engagements pour une utilisation responsable, supervisée et transparente de l’intelligence artificielle.',
  },
]

export const atnaQuestions = [
  'Comment mes données sont-elles utilisées ?',
  'Comment modifier mes consentements ?',
  'Comment supprimer mon compte ?',
]
